// The switch of the BI Property comparison (D12, D22): the build variable REACT_APP_BI_COMPARE=false hides the button
// "Compare properties" and sends the comparison address back to the report, for every user. Default: on. To turn it off,
// set the variable and build the frontend again (no code change, no backend change).
export const compareOn = (): boolean => process.env.REACT_APP_BI_COMPARE !== 'false';
